/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    BuergschaftsantragRequest,
    PostBuergschaftsantragTemplateUploadBody,
    PostBuergschaftsantragTemplateUploadParams
} from '../kreditportalBackendAPI.schemas';


interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (
      preserveRequiredNullables &&
      value === null &&
      requiredNullableKeys.has(key)
    ) {
      filteredParams[key] = null;
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BuergschaftsantragApiService {
  private readonly http = inject(HttpClient);
/**
 * Dieser Service ermöglicht das Einreichen eines neuen Bürgschaftsantrages. (Eine der Hauptfunktionalitäten des Kreditportals.) Triggert via Zebra in Puma einen neuen Antragsprozess.
 * @summary Einreichen eines Bürgschaftsantrags
 */
 postBuergschaftsantrag<TData = void>(buergschaftsantragRequest: BuergschaftsantragRequest, options?: HttpClientBodyOptions): Observable<TData>;
 postBuergschaftsantrag<TData = void>(buergschaftsantragRequest: BuergschaftsantragRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postBuergschaftsantrag<TData = void>(buergschaftsantragRequest: BuergschaftsantragRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postBuergschaftsantrag<TData = void>(
    buergschaftsantragRequest: BuergschaftsantragRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/buergschaftsantrag`,
      buergschaftsantragRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/buergschaftsantrag`,
      buergschaftsantragRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/buergschaftsantrag`,
      buergschaftsantragRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht es Kunden Auftraggeber-Bürgschaftsvorlagen für den Bürgschaftsantrag hochzuladen.
 * @summary Upload von Bürgschaftsvorlagen für den Bürgschaftsantrag
 */
 postBuergschaftsantragTemplateUpload(params: PostBuergschaftsantragTemplateUploadParams,
    postBuergschaftsantragTemplateUploadBody?: PostBuergschaftsantragTemplateUploadBody, options?: HttpClientBodyOptions): Observable<string>;
 postBuergschaftsantragTemplateUpload(params: PostBuergschaftsantragTemplateUploadParams,
    postBuergschaftsantragTemplateUploadBody?: PostBuergschaftsantragTemplateUploadBody, options?: HttpClientEventOptions): Observable<HttpEvent<string>>;
 postBuergschaftsantragTemplateUpload(params: PostBuergschaftsantragTemplateUploadParams,
    postBuergschaftsantragTemplateUploadBody?: PostBuergschaftsantragTemplateUploadBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<string>>;
  postBuergschaftsantragTemplateUpload(
    params: PostBuergschaftsantragTemplateUploadParams,
    postBuergschaftsantragTemplateUploadBody?: PostBuergschaftsantragTemplateUploadBody, options?: HttpClientObserveOptions): Observable<string | HttpEvent<string> | AngularHttpResponse<string>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post(
      `/api/buergschaftsantrag/templateUpload`,
      postBuergschaftsantragTemplateUploadBody,{
        responseType: 'text',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    ) as Observable<HttpEvent<string>>;
    }

    if (options?.observe === 'response') {
      return this.http.post(
      `/api/buergschaftsantrag/templateUpload`,
      postBuergschaftsantragTemplateUploadBody,{
        responseType: 'text',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    ) as Observable<AngularHttpResponse<string>>;
    }

    return this.http.post(
      `/api/buergschaftsantrag/templateUpload`,
      postBuergschaftsantragTemplateUploadBody,{
        responseType: 'text',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    ) as Observable<string>;
  }
};

